import { getInitialState } from './default-state.js'

export const state = getInitialState()
